import * as Cesium from 'cesium';

/**
 * Vertical tilt slider (right edge): 90° = straight top-down, 0° = side view.
 * Bidirectional: dragging the slider tilts the camera around the point at the
 * screen center, and tilting via touch/mouse updates the slider position.
 */
export function setupTiltSlider(viewer) {
  const slider = document.getElementById('tiltSlider');
  const valueLabel = document.getElementById('tiltValue');
  let dragging = false;

  function pickPivot() {
    // Punkt in der Bildschirmmitte, um den gekippt wird
    const canvas = viewer.scene.canvas;
    const center = new Cesium.Cartesian2(canvas.clientWidth / 2, canvas.clientHeight / 2);
    const ray = viewer.camera.getPickRay(center);
    let pivot = ray ? viewer.scene.globe.pick(ray, viewer.scene) : undefined;
    if (!pivot) {
      pivot = viewer.camera.pickEllipsoid(center, viewer.scene.globe.ellipsoid);
    }
    return pivot;
  }

  function applyTilt(degrees) {
    // Während Cesium ein Entity verfolgt nicht eingreifen — dort steuert Cesium
    if (viewer.trackedEntity) return;

    const pivot = pickPivot();
    if (!pivot) return;

    const range = Cesium.Cartesian3.distance(viewer.camera.position, pivot);
    viewer.camera.lookAt(
      pivot,
      new Cesium.HeadingPitchRange(
        viewer.camera.heading,
        -Cesium.Math.toRadians(degrees),
        range
      )
    );
    // Transform sofort wieder freigeben, sonst bleibt die Kamera "gefesselt"
    viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
    viewer.scene.requestRender();
  }

  function updateLabel(degrees) {
    if (valueLabel) valueLabel.textContent = `${Math.round(degrees)}°`;
  }

  slider.addEventListener('input', () => {
    const degrees = parseFloat(slider.value);
    updateLabel(degrees);
    applyTilt(degrees);
  });

  slider.addEventListener('pointerdown', () => { dragging = true; });
  document.addEventListener('pointerup', () => { dragging = false; });

  // Rückkanal: Finger-/Mausneigung der Kamera auf den Schieber übertragen
  viewer.camera.percentageChanged = 0.01;
  viewer.camera.changed.addEventListener(() => {
    if (dragging) return;
    const degrees = Cesium.Math.clamp(
      -Cesium.Math.toDegrees(viewer.camera.pitch),
      0,
      90
    );
    slider.value = String(Math.round(degrees));
    updateLabel(degrees);
  });

  // Initialwert aus der aktuellen Kameraneigung
  const initial = Cesium.Math.clamp(-Cesium.Math.toDegrees(viewer.camera.pitch), 0, 90);
  slider.value = String(Math.round(initial));
  updateLabel(initial);
}
